import { createResourceSlice, resourceInitialState } from 'store/ResourceSlice';
import { StateResource } from 'typings/state';

export const initialState: StateResource = resourceInitialState();

const slice = createResourceSlice({
    name: 'unavailability',
    initialState,
});

export const unavailability = slice.reducer;
export const actions: typeof slice.actions = slice.actions;
